//----------------------------
// create changed spell entry
//----------------------------
export default function createChangedSpellEntry({
  name = '', // spell name
  action = '', // 'ADD', 'UPDATE', 'DELETE'
  type = '', // character, item or rune (needed to determine which api call)
  id = null, // for character_spell/character_rune_spell or character_item_spell updates/deletes / temp-id for new spell (tracking only)
  payload = {},
  character_rune_name = '',
  casting_rune_name = '',
  secondary_rune_name = '',
} = {}) {
  //--------------------------------------------------------------------------
  // basic validation - name and action are required for a valid change entry
  //--------------------------------------------------------------------------
  if (!name || !action) {
    throw new Error('Invalid input: name and action are required')
  }

  //--------------------------------------------------------------------------
  // base output shared by all actions
  //--------------------------------------------------------------------------
  const out = {
    name,
    action,
    type, // character, item or rune (used later to pick API endpoint)
  }

  //---------------------------------------------------------------------
  // for ADD & UPDATE: just preserve the payload exactly as provided
  // - trackSpellChanges already constructs the right shape including
  //   character, spell, mag, character_item, character_rune, etc.
  //---------------------------------------------------------------------
  if (action === 'ADD' || action === 'UPDATE') {
    const cleanPayload = { ...(payload || {}) }

    // character_item and character_rune are mutually exclusive links.
    // If either is null/undefined, drop the key entirely so the
    // backend only sees fields that are actually set.
    ;['character_item', 'character_rune'].forEach((key) => {
      if (cleanPayload[key] == null) {
        delete cleanPayload[key]
      }
    })

    out.payload = cleanPayload
  }

  //-----------------------------------------------------------------------------------
  // UPDATE & DELETE: id = character_spell/character_rune_spell or character_item_spell id
  // ADD: id = temp id for tracking (actual character-id + static spell-id provided inside payload for server-side creation)
  //-----------------------------------------------------------------------------------
  if (id != null) {
    out.id = id
  }

  if (character_rune_name) {
    out.character_rune_name = character_rune_name
  }

  if (casting_rune_name) {
    out.casting_rune_name = casting_rune_name
  }

  if (secondary_rune_name) {
    out.secondary_rune_name = secondary_rune_name
  }

  return out
}
